// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchFactures({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/factures`)
      .then(({ data }) => {
        commit('addFactures', data)
      })
  },
  async fetchFacturesPage({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '', code = '', numero = '', filmTitle = '', after = '', before = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
      ...(code && { code }),
      ...(numero && { numero }),
      ...(filmTitle && { filmTitle }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/factures/page?${queryParams}`);
    commit("addFacturesPage", data)
    return data;
  },
  createFacture({ commit }, facture) {
    return post('/canal/factures', facture)
      .then(({ data }) => {
        commit('addFacture', data)
      })
  },
  updateFacture({ commit }, facture) {
    return put(`/canal/factures${facture.id}`, facture)
      .then(({ data }) => {
        commit('replaceFacture', data)
      })
  },
  createOrUpdateFacture({ dispatch }, facture) {
    if (facture.id !== undefined) {
      return dispatch('updateFacture', facture)
    } else {
      return dispatch('createFacture', facture)
    }
  },
  selectFacture({ commit }, facture) {
    commit('setFacture', facture)
  },
  async statistiqueFacture() {
    let data = await get(`/canal/factures/statistiques/courbe`);
    return data;
  },
  remboursement({ commit }, facture) {
    return post('/canal/remboursement', facture)
      .then(({ data }) => {})
  },
  async fetchRemboursement({ commit }, params = {}) {
    const { page = 0, size = 10, sort = ''} = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
    }).toString();

    let { data } = await get(`/canal/remboursement/page?${queryParams}`);
    //commit("addRemboursement", data)
    return data;
  },
  
}
